import script from "./UploadModuleModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadModuleModal.vue?vue&type=script&setup=true&lang=js"

import "./UploadModuleModal.vue?vue&type=style&index=0&id=1e5f0fde&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e5f0fde"]])

export default __exports__